import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

export default function DatadogUserIdentify() {
    const isAuthenticated = useIsAuthenticated();
    const { accounts } = useMsal();
    const user = accounts[0];

    useEffect(() => {
        if (isAuthenticated && user) {
            datadogRum.setUser({
                id: user.localAccountId,
                name: user.name ?? user.username,
                email: user.username
            });
        } else {
            datadogRum.clearUser();
        }
    }, [isAuthenticated, user]);

    return null;
}
